import { getActiveUser } from "@noom/hive-auth";
import type {
  EvaluateProductEligibilityRequestProto_Body,
  EvaluateProductEligibilityResponseProto,
} from "@noom/noom-contracts/noom_contracts/billing/product_catalog/product_eligibility_service";

import { appConfig } from "src/config";
import { getCookieAccessCode } from "src/utils/authCookieParser";
import { send } from "src/utils/fetch";
import { trackTask } from "src/utils/monitoring/events/tasks";
import getStore from "src/utils/redux/store";

function resolveAccessCode(): string | undefined {
  // Cookie before Redux so accessCode matches send()'s bearer (hive → cookie).
  return (
    getActiveUser()?.accessCode ??
    getCookieAccessCode() ??
    getStore().getState().userData.access_code
  );
}

export async function evaluateProductEligibility(
  productNames: string[]
): Promise<EvaluateProductEligibilityResponseProto> {
  const accessCode = resolveAccessCode();
  if (!accessCode) {
    throw new Error("Access code is required to evaluate product eligibility");
  }
  if (productNames.length === 0) {
    throw new Error("At least one product name is required");
  }

  const body: EvaluateProductEligibilityRequestProto_Body = {
    accessCode,
    productNames,
    saleItemIds: [],
    limit: productNames.length,
  };

  const task = trackTask("EvaluateProductEligibility", {
    productCount: productNames.length,
  });
  task.start();

  try {
    const response = await send<EvaluateProductEligibilityResponseProto>(
      "POST",
      `${appConfig.BILLING_CORE_API_URL}/billing/v2/productEligibility/evaluate`,
      body
    );
    task.success();
    return response;
  } catch (ex) {
    task.failed(ex);
    throw ex;
  }
}
